import SectionCard from 'app/components/presentation/containers/SectionCard';
import { flexCascade } from 'app/constants/Styles';
import { createStyles } from 'app/utils/css';
import React, { ReactNode } from 'react';

/**
 * Forms that are contained inside a section card.
 */
const FormSectionCard = ({
  children,
  cardPadding = '42px',
  header,
  headerActionItem,
}: {
  children: ReactNode,
  cardPadding?: '42px' | '42px 0',
  header?: ReactNode,
  headerActionItem?: ReactNode,
}) => (
  <Styles>{(css) => (
    <SectionCard
      cardPadding={cardPadding}
      sectionHeader={header}
      sectionHeaderActionItem={headerActionItem}
    >
      <div className={css('content')}>{children}</div>
    </SectionCard>
  )}</Styles>
);

const Styles = createStyles({
  content: {
    ...flexCascade,
    fontSize: '14px',
  },
});

export default FormSectionCard;
